module.exports = __webpack_public_path__ + "static/media/fresh paint.d51fa818.jpg";